import { render, staticRenderFns } from "./FrequenciaEnvioEmailModal.vue?vue&type=template&id=54ca339a&scoped=true"
import script from "./FrequenciaEnvioEmailModal.vue?vue&type=script&lang=js"
export * from "./FrequenciaEnvioEmailModal.vue?vue&type=script&lang=js"
import style0 from "./FrequenciaEnvioEmailModal.vue?vue&type=style&index=0&id=54ca339a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ca339a",
  null
  
)

export default component.exports